

exports.__esModule = true;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$SidebarManageWalletRoute', {

    path: 'sidebarManageWallet',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'manage_wallet',
        templateName: 'tray/manageWallet',
        pageGoal: 'Manage Instruments',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-manage-wallet',
                'pagename2': '%::fullpage-manage-wallet:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    loginRequired: true,
    children: []
});


_squid.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-manage-wallet/route.js
// module id = ./pages/xo-sidebar-manage-wallet/route.js
// module chunks = 1